import axios from "axios";

const instance = axios.create({
  baseURL: process.env.REACT_APP_ENV === "development" ? "http://localhost:5001/" : process.env.REACT_APP_API,
  timeout: 60 * 1000,
});

// Add a request interceptor
instance.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
instance.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  }
);

// Sin respuesta del servidor: el navegador perdió la red o se cortó la conexión (axios 0.21 no trae `code`)
export const esErrorDeRed = (err) => Boolean(err) && !err.response && !axios.isCancel(err);

// Texto para mostrar al usuario: avisa de la conexión, o usa el mensaje del servidor si lo hay
export const mensajeError = (err, porDefecto = "Hubo un error al comunicarse con el servidor") => {
  if (esErrorDeRed(err)) return "No se pudo conectar con el servidor. Revise su conexión a internet e intente nuevamente.";
  return (err && err.response && err.response.data && err.response.data.message) || porDefecto;
};

export default instance;
